// Version : 1.0.0
// Author : AGALYA

import RationCardDetailsActionType from './ration-card-details.types';

/** ***************** Ration Card Details Update Start ************************/
export const updateRationCardStart = (rationCardCredentials: any) => ({
	type: RationCardDetailsActionType.UPDATE_RATION_CARD_START,
	payload: rationCardCredentials,
});

export const updateRationCardSuccess = (rationCardSuccess: any) => ({
	type: RationCardDetailsActionType.UPDATE_RATION_CARD_SUCCESS,
	payload: rationCardSuccess,
});

export const updateRationCardFailure = (rationCardFailure: any) => ({
	type: RationCardDetailsActionType.UPDATE_RATION_CARD_FAILURE,
	payload: rationCardFailure,
});

export const updateRationCardResponseResetStart = () => ({
	type: RationCardDetailsActionType.UPDATE_RATION_CARD_RESPONSE_REST_START,
});

export const updateRationCardResponseChanged = () => ({
	type: RationCardDetailsActionType.UPDATE_RATION_CARD_RESPONSE_CHANGED,
});
/** ***************** Ration Card Details Update End ************************/
